import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { WorkflowRepository, WorkflowService } from '@softapps/gewerbe/workflow';
import { stockPostingGuard } from './guards/stock-psoting.guard';
import { ItemRepository } from './repository/item.repository';
import { LagerScanRepository } from './repository/lager-scan.repository';
import { ProductRepository } from './repository/product.repository';
import { StockPostingRepository } from './repository/stock-posting.repository';
import { ItemPropertyPrefillService } from './services/item-property-prefill.service';
import { ItemService } from './services/item.service';
import { SelectedLagerService } from './services/selected-lager.service';
import { StockPostingService } from './services/stock-posting.service';

export const einseitigeLagerbuchungRoutes: Routes = [
  {
    path: 'mde-stockposting',
    canActivate: [AuthenticationGuard],
    providers: [
      StockPostingService,
      StockPostingRepository,
      ProductRepository,
      SelectedLagerService,
      LagerScanRepository,
    ],
    children: [
      {
        path: 'select-lager',
        loadComponent: () => import('./pages/select-lager/select-lager'),
      },
      {
        path: 'stock-symbol',
        loadComponent: () =>
          import('./pages/select-lagersymbol/select-lagersymbol.component'),
      },
      {
        path: '',
        canActivate: [stockPostingGuard],
        providers: [ItemRepository, ItemService, ItemPropertyPrefillService],
        children: [
          {
            path: 'artikel-erfassen',
            children: [
              {
                path: 'search',
                loadComponent: () =>
                  import('./pages/artikel-erfassen/schritt1/schritt1.component'),
              },
              {
                path: ':id',
                loadComponent: () =>
                  import('./pages/artikel-erfassen/schritt2/schritt2.component'),
              },
              {
                path: '**',
                redirectTo: '/mde-stockposting/artikel-erfassen/search',
              },
            ],
          },
          {
            path: 'erfassung',
            loadComponent: () => import('./pages/main/main.component'),
          },
        ],
      },
      {
        path: 'workflow/:id',
        providers: [WorkflowService, WorkflowRepository],
        loadComponent: () =>
          import('./pages/stock-posting-workflow/stock-posting-workflow'),
      },
      {
        path: '**',
        redirectTo: '/mde-stockposting/erfassung',
      },
    ],
  },
];
